import { FC } from 'react';

import * as Styles from './buttons.styles';

const PillButtonColorTheme: FC<React.HTMLAttributes<HTMLButtonElement>> = (props) => {
  return (
    <Styles.PillButtonColorTheme {...props} id={props.id || 'pill-button-color-theme'} />
  );
};

export default PillButtonColorTheme;
